import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Modal, Stack, Typography } from "@mui/material";

interface IProps {
  filesPickerInfoModal: { infoModalOpen: boolean; isSendAiAvailable: boolean } | null;
  setFilesPickerInfoModal: React.Dispatch<
    React.SetStateAction<{ infoModalOpen: boolean; isSendAiAvailable: boolean } | null>
  >;
}

export const FilesPickerInfoModal: React.FC<IProps> = ({ filesPickerInfoModal, setFilesPickerInfoModal }) => {
  return (
    <Modal open={!!filesPickerInfoModal?.infoModalOpen} onClose={() => setFilesPickerInfoModal(null)}>
      <Stack
        sx={{
          padding: "32px",
          borderRadius: "8px",
          background: "#fff",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "520px",
          height: "236px"
        }}
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid  #DAE0E2" }}
        >
          <Typography>Ask Ai</Typography>
          <IconButton onClick={() => setFilesPickerInfoModal(null)}>
            <CloseIcon className="icon" />
          </IconButton>
        </Stack>
        <Typography>
          {filesPickerInfoModal?.isSendAiAvailable
            ? "We are working on your request and will notify you as soon as everything is ready."
            : "In order to generate an answer using AI, add at least one question for the section."}
        </Typography>
        <Stack flexDirection="row-reverse" flex="" alignItems="center">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#071F35", minWidth: "46px" }}
            onClick={() => setFilesPickerInfoModal(null)}
          >
            OK
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
